import { __assign, __rest } from "tslib";
import * as React from "react";
import chroma from "chroma-js";
import { getCoordinatesFromEvent, initAnimation } from "./utils";
export var HandSigned = React.forwardRef(function (_a, ref) {
    var _b = _a.color, color = _b === void 0 ? "#000000" : _b, _c = _a.initialData, initialData = _c === void 0 ? [] : _c, _d = _a.width, width = _d === void 0 ? "700" : _d, _e = _a.height, height = _e === void 0 ? "300" : _e, props = __rest(_a, ["color", "initialData", "width", "height"]);
    var internalRef = React.useRef(null);
    var _f = React.useState(initialData || []), raw = _f[0], setRaw = _f[1];
    var _g = React.useState(false), isDrawing = _g[0], setIsDrawing = _g[1];
    var _h = React.useState(null), context = _h[0], setContext = _h[1];
    var handleMouseDown = function (event) {
        if (context) {
            var _a = getCoordinatesFromEvent(event), x = _a.x, y = _a.y;
            context.beginPath();
            context.moveTo(x, y);
            setIsDrawing(true);
        }
    };
    var handleMouseMove = function (event) {
        if (context && isDrawing) {
            var _a = getCoordinatesFromEvent(event), x = _a.x, y = _a.y;
            context.lineTo(x, y);
            context.strokeStyle = color;
            context.stroke();
            raw.push({ x: x, y: y });
            setRaw(raw);
        }
    };
    var handleMouseUp = function (event) {
        if (context && isDrawing) {
            var _a = getCoordinatesFromEvent(event), x = _a.x, y = _a.y;
            context.lineTo(x, y);
            context.strokeStyle = color;
            context.stroke();
            raw.push(null);
            setRaw(raw);
            setIsDrawing(false);
        }
    };
    React.useImperativeHandle(ref, function () { return ({
        internalRef: internalRef,
        getRawData: function () {
            return raw.filter(function (_, index) { return index < raw.length - 1; });
        },
        clear: function () {
            if (context) {
                setRaw([]);
                context.clearRect(0, 0, context.canvas.width, context.canvas.height);
            }
        },
        getDataURL: function () {
            if (context) {
                var canvas = context.canvas;
                return canvas.toDataURL("image/png");
            }
            return "";
        },
    }); });
    var init = function () {
        var current = internalRef.current;
        if (current) {
            var context_1 = current.getContext("2d");
            if (context_1) {
                var rgbColor = chroma(color).rgb();
                context_1.shadowColor = "rgba(".concat(rgbColor[0], ", ").concat(rgbColor[1], ", ").concat(rgbColor[2], ", .5)");
                context_1.shadowBlur = 1.5;
                context_1.lineCap = "round";
                context_1.lineJoin = "round";
                context_1.lineWidth = 1;
                setContext(context_1);
            }
        }
    };
    React.useEffect(function () {
        init();
    }, []);
    React.useEffect(function () {
        if (context) {
            initAnimation(context, initialData, color);
        }
    }, [context]);
    return (React.createElement("canvas", __assign({}, props, { width: width, height: height, ref: internalRef, onMouseDown: handleMouseDown, onTouchStart: handleMouseDown, onMouseMove: handleMouseMove, onTouchMove: handleMouseMove, onMouseUp: handleMouseUp, onMouseOut: handleMouseUp, onTouchEnd: handleMouseUp })));
});
